import React from 'react';

interface StepperProps {
  initialValue?: number;
  onChange: (value: number) => void;
}

export const Stepper = ({ initialValue, onChange }: StepperProps) => {
  const [value, setValue] = React.useState(initialValue || 1);

  const updateValue = React.useCallback(
    (value: number) => {
      onChange(value);
      setValue(value);
    },
    [setValue, onChange],
  );

  const handleChange = (newValue: string) => {
    const parsedValue = parseInt(newValue, 10);
    if (parsedValue < 10000) {
      updateValue(parsedValue);
    }
  };
  const increment = () => {
    updateValue(value + 1);
  };
  const decrement = () => {
    if (value > 1) {
      updateValue(value - 1);
    }
  };

  return (
    <div className="rounded-md grid grid-cols-3 w-36 border h-12">
      <button data-testid="stepper-decrement" onClick={decrement}>
        <span className="text-lg block material-symbols-outlined" aria-hidden>
          remove
        </span>
      </button>

      <input
        data-testid="stepper-input"
        type="number"
        step="1"
        className="no-arrows text-center focus:outline-none border-l border-r text-lg"
        value={value}
        onChange={(e) => handleChange(e.target.value)}
      />
      <button data-testid="stepper-increment" onClick={increment}>
        <span className="text-lg block material-symbols-outlined" aria-hidden>
          add
        </span>
      </button>
    </div>
  );
};
